import React from "react";
import { MenuItem } from "react-contextmenu";
import SimpleErrorBoundary from "widgets/SimpleErrorBoundary";
import { noop } from "utils/common";

export function ActionFragment({ component, actionContext }){
	/*
		This is broken out so that an ErrorBoundary can be used to isolate broken actions,
		so that the whole menu doesn't break.

		If `component(actionContext)` is called in the scope of the Menu component, and the
		action has an error, it can't be caught in an ErrorBoundary inside Menu.

		Calling `component(actionContext)` inside this component allows a boundary in Menu to catch it.
	*/
	return (
		<React.Fragment>
			{component(actionContext)}
		</React.Fragment>
	);
}

function MenuItemDivider(props){
	return (
		<MenuItem
			{...props}
			divider
		/>
	);
}

export function buildList(actionLists = [], actionContext = {}, DividerComponent = MenuItemDivider){
	let key = 0;

	let displayableCount = 0;

	let menuItems = actionLists.reduce((prev, list, index) => {
		let displayableActions = list.filter(({ shouldDisplay = ALWAYS_DISPLAY }) => { // Always display if `shouldDisplay` is missing.
			return shouldDisplay(actionContext);
		});
		displayableCount += displayableActions.length;

		let listActions = displayableActions.map(({ component = noop }) => {
			let newElement = (
				<SimpleErrorBoundary key={key}>
					<ActionFragment {...{ component, actionContext }} />
				</SimpleErrorBoundary>
			);
			key += 1;

			return newElement;
		});

		let hasItems = displayableActions.length !== 0;

		if(hasItems){ // If the list has no displayableActions, don't add anything to the menu
			if(index > 0 && prev.length > 0){
				// HOPI-171: Only add the divider if the list has items in it, and there's already something else above it
				prev.push(
					<DividerComponent
						key = {key}
					/>
				);
				key += 1;
			}
			prev.push(listActions);
		}

		return prev;
	}, []);

	let hasItems = displayableCount > 0;

	return [menuItems, hasItems];
}

export function ALWAYS_DISPLAY(){
	return true;
}
